<template>
	<Instructor/>
</template>

<script>
// @ is an alias to /src
import Instructor from '@/components/Instructor/Instructor.vue'

export default {
  name: 'instructor',
  components: {
    Instructor
  }
}
</script>
